import cn from 'classnames'
import React, { ComponentProps } from 'react'
import { css } from 'styled-components'

type ChevronIconProps = {
  className?: string
  direction?: 'up' | 'down' | 'left' | 'right'
} & ComponentProps<'svg'>

export default function ChevronIcon(props: ChevronIconProps) {
  const { className = '', direction = 'down', ...rest } = props

  // The glyph is drawn pointing down and CSS rotation is clockwise, so left is
  // a quarter turn forward and right a quarter turn back, not the reverse.
  let rotationDegrees
  switch (direction) {
    case 'up':
      rotationDegrees = '180deg'
      break
    case 'left':
      rotationDegrees = '90deg'
      break
    case 'right':
      rotationDegrees = '-90deg'
      break
    case 'down':
    default:
      rotationDegrees = '0'
  }

  return (
    <svg
      className={cn('ChevronIcon', className)}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      css={css`
        transform: rotate(${rotationDegrees});
        transition: transform 0.3s ease;

        /* Here rather than at each call site: the transition ships with the
           icon, so the guard on it should too. */
        @media (prefers-reduced-motion: reduce) {
          transition: none;
        }
      `}
      {...rest}
    >
      <path
        d="M12 14.94 6.53 9.47a.75.75 0 0 0-1.06 1.06l6 6a.75.75 0 0 0 1.06 0l6-6a.75.75 0 0 0-1.06-1.06L12 14.94Z"
        fill={props.fill || 'var(--color-cta)'}
      />
    </svg>
  )
}
